import {
  SET_WORKSPACE_LOADER,
  SET_WORKSPACE_COMMENT_LOADER,
  SET_WORKSPACE_DATA,
  SET_WORKSPACE_DETAIL,
  SET_WORKSPACE_ACTIVITY,
  SET_WORKSPACE_PAGE
} from "../actionTypes/workspace"

const initialState = {
  data: {
    main: [],
    document: {},
    activity: [],
    pagination: {}
  },
  meta: {
    isLoading: false,
    isLoadingComment: false
  }
}

export default (state = initialState, action) => {
  const {type, payload} = action
  switch (type) {
    case SET_WORKSPACE_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          main: payload
        }
      }
    case SET_WORKSPACE_PAGE:
      return {
        ...state,
        data: {
          ...state.data,
          pagination: payload
        }
      }
    case SET_WORKSPACE_LOADER:
      return {
        ...state,
        meta: {
          ...state.meta,
          isLoading: payload
        }
      }
    case SET_WORKSPACE_COMMENT_LOADER:
      return {
        ...state,
        meta: {
          ...state.meta,
          isLoadingComment: payload
        }
      }
    case SET_WORKSPACE_DETAIL:
      return {
        ...state,
        data: {
          ...state.data,
          document: payload
        }
      }
    case SET_WORKSPACE_ACTIVITY:
      return {
        ...state,
        data: {
          ...state.data,
          activity: payload
        }
      }
    default:
      return state
  }
}
